module.exports = __webpack_public_path__ + "static/media/download.8da43721.svg";